"use client"

import { useState, useEffect } from "react"
import { ArrowUp } from "lucide-react"
import { useTranslations } from "next-intl"
import { Button } from "@/components/ui/button"

export function ScrollToTop() {
  const t = useTranslations("common")
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    let rafId = 0

    const handleScroll = () => {
      if (rafId) return
      rafId = window.requestAnimationFrame(() => {
        setIsVisible(window.scrollY >= 2 * window.innerHeight)
        rafId = 0
      })
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", handleScroll, { passive: true } as EventListenerOptions)
      if (rafId) window.cancelAnimationFrame(rafId)
    }
  }, [])

  const handleScrollToTop = () => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "instant" : "smooth" })
  }

  return (
    <Button
      variant="outline"
      aria-label={t("scrollToTop")}
      onClick={handleScrollToTop}
      className={`fixed bottom-6 right-6 z-30 size-11 min-w-11 min-h-11 rounded-full transition-opacity duration-200 motion-reduce:transition-none pb-[env(safe-area-inset-bottom)] ${
        isVisible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </Button>
  )
}
